<template>
  <div class="entry-history-table">
    <el-table :data="entries" stripe @header-click="headerClick" style="width: 100%" empty-text="データがありません。">
      <el-table-column label="日時" :sort-by="sortBy" :render-header="renderHeader" min-width="30%">
        <template slot-scope="scope">{{ formatDatetime(scope.row.date) }}</template>
      </el-table-column>
      <el-table-column label="キャンペーン名" sort-by="campaignName" :render-header="renderHeader" min-width="70%">
        <template slot-scope="scope">
          <div>{{ scope.row.campaignName }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent, PropType } from 'vue'

import Util from '@/client/core/util'
import { formatDatetime } from '@/client/filters/filters'

export default defineComponent({
  props: {
    entries: Array as PropType<readonly unknown[]>,
    sortBy: String
  },
  methods: {
    formatDatetime,

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.sortBy, column.sortBy))
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (!column.sortBy) {
        return
      }
      let sortBy = column.sortBy

      if (column.sortBy.indexOf('-') === 0) {
        if (this.sortBy === column.sortBy) {
          sortBy = column.sortBy.substring(1)
          this.$emit('sorting', { sortBy })
        } else {
          sortBy = column.sortBy
          this.$emit('sorting', { sortBy })
        }
      } else {
        if (this.sortBy === column.sortBy) {
          sortBy = '-' + column.sortBy
          this.$emit('sorting', { sortBy })
        } else {
          this.$emit('sorting', { sortBy })
        }
      }
    }
  }
})
</script>
